import { Dimensions } from '../../core/types/dimensions.js';

export const getHiveCenteringOffset = (
  graphSize: Dimensions,
  cols: number,
  tileWidth: number,
  hiveHeight: number,
  gap: number,
) => {
  const widthSavedForHive = cols * (tileWidth + gap) - gap;
  const remainingWidth = graphSize.width - widthSavedForHive;
  const horizontalOffset = remainingWidth / 2;
  const verticalOffset = (graphSize.height - hiveHeight) / 2;

  return { left: horizontalOffset, top: verticalOffset };
};
